import React, { useState } from 'react';
import { FormControlLabel, makeStyles, Radio, RadioGroup, TextField } from '@material-ui/core';
import { LoadingStates, ScriptPathTypesV2, ScriptPathV2 } from 'typings';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';

interface ScriptStepChoicesProps {
  initialOtherValue: string;
  onPathChange: Function;
  onOtherChange: Function;
  scriptPaths: ScriptPathV2[];
  selectedPath: ScriptPathV2 | null;
}

const useStyles = makeStyles((theme) => ({
  radioGroup: {
    marginBottom: theme.spacing(1.5),
    paddingLeft: '8px',
  },
  formControlLabel: {
    alignItems: 'start',
  },
  radioButton: {
    marginRight: '3px',
    padding: '3px',
  },
  radioLabel: {
    display: 'inline-block',
    fontSize: '0.875rem',
    lineHeight: 1.3,
    paddingTop: '4px',
  },
  otherTextField: {
    marginBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(2.5),
    width: '100%',
  },
  otherTextInput: {
    fontSize: '0.875rem',
  },
}));

const ScriptStepChoices = ({
  initialOtherValue,
  onPathChange,
  onOtherChange,
  scriptPaths,
  selectedPath,
}: ScriptStepChoicesProps) => {
  const styles = useStyles();

  const isLoading = useSelector(
    (state: RootState) => state.script.loadingState === LoadingStates.LOADING
  );
  const [otherValue, setOtherValue] = useState(initialOtherValue);

  return (
    <RadioGroup
      className={styles.radioGroup}
      value={selectedPath?.value ?? ''}
      onChange={(event) => onPathChange(event.target.value)}
    >
      {scriptPaths.map((scriptPath) => (
        <div key={`path:${scriptPath.value}`}>
          <FormControlLabel
            className={styles.formControlLabel}
            label={<span className={styles.radioLabel}>{scriptPath.label}</span>}
            value={scriptPath.value}
            disabled={isLoading}
            control={<Radio size="small" className={styles.radioButton} />}
          />
          {scriptPath.type === ScriptPathTypesV2.OTHER &&
            scriptPath.value === selectedPath?.value && (
              <TextField
                multiline
                value={otherValue}
                disabled={isLoading}
                onChange={(event) => setOtherValue(event?.target.value)}
                onBlur={(event) => onOtherChange(event.target.value)}
                placeholder="-"
                className={styles.otherTextField}
                inputProps={{
                  className: styles.otherTextInput,
                }}
              />
            )}
        </div>
      ))}
    </RadioGroup>
  );
};

export default ScriptStepChoices;
